module.exports = __webpack_public_path__ + "static/media/7-2.d93861f1.mp3";